import { isAfter, isValid, parse } from "date-fns";
import * as Yup from "yup";

export const identificationFormValidationSchema = Yup.array().of(
  Yup.object().shape({
    passengerId: Yup.string().required(
      "tix_ui_identification_form_step_1_passenger_id_required"
    ),
    idType: Yup.string().required(
      "tix_ui_identification_form_step_1_id_type_required"
    ),
    dateOfExpiry: Yup.string()
      .required("tix_ui_identification_form_step_1_date_of_expiry_required")
      .matches(
        new RegExp("[1-2][0-9][0-9][0-9]-[0-1][0-9]-[0-3][0-9]"),
        "tix_ui_identification_form_step_1_date_of_expiry_wrong_format"
      )
      .test(
        "is-valid-date",
        "tix_ui_identification_form_step_1_date_of_expiry_not_valid",
        (value) => {
          const parsedDate = parse(value!, "yyyy-MM-dd", new Date());
          return isValid(parsedDate);
        }
      )
      .test(
        "is-in-past",
        "tix_ui_identification_form_step_1_date_of_expiry_past_date",
        (value) => {
          const parsedDate = parse(value!, "yyyy-MM-dd", new Date());
          return isAfter(parsedDate, new Date());
        }
      ),
    idNumber: Yup.string().required(
      "tix_ui_identification_form_step_1_id_number_required"
    ),
    issueCountry: Yup.string().required(
      "tix_ui_identification_form_step_1_issue_country_required"
    ),
  })
);
